import styled from "styled-components";

export const Session = styled.div`
  min-height: 768px;
  padding: 0 0 20px 0;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
